module.exports = __webpack_public_path__ + "static/media/planimg.bd141862.png";